import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";

const STAGES = [
  "Принимаем ответы…",
  "Извлекаем структурированные признаки из открытых ответов…",
  "Применяем актуальную шкалу…",
  "Считаем компоненты трёх индексов…",
  "Подбираем рекомендации…",
  "Формируем профиль…",
];

export default function LoadingScreen() {
  const { id } = useParams();
  const nav = useNavigate();
  const [stage, setStage] = useState(0);

  useEffect(() => {
    let alive = true;
    let interval = setInterval(() => {
      setStage((s) => (s + 1 < STAGES.length ? s + 1 : s));
    }, 700);
    api.post(`/api/submissions/${id}/score`)
      .then(() => alive && nav(`/result/${id}`))
      .catch(() => alive && nav(`/result/${id}`));
    return () => { alive = false; clearInterval(interval); };
  }, [id, nav]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-8">
      <div className="max-w-2xl w-full">
        <div className="label-mono">PROCESSING</div>
        <h1 className="mt-4 text-4xl md:text-5xl font-medium tracking-tight">Расчёт результата</h1>
        <div className="mt-10 space-y-3 font-mono text-sm">
          {STAGES.map((s, i) => (
            <div key={i} className={`flex gap-3 transition-opacity ${i <= stage ? "opacity-100" : "opacity-30"}`}>
              <span className="text-foreground/50">{String(i + 1).padStart(2, "0")}</span>
              <span>{s}</span>
              {i < stage && <span className="ml-auto label-mono">OK</span>}
              {i === stage && <span className="ml-auto label-mono animate-pulse">…</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
